import * as z from "zod";
import { recordConnectorUsage, usageRef } from "../connectorUsages";
import { matchesUrlPattern } from "../connectors/matchesUrlPattern";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { parseGitSkillSource } from "../skills/gitSource";
import { mutator } from "./mutator";

export const inspectGitSkillSourceSchema = z.object({
  sourceId: z.string(),
  remoteUrl: z.string(),
  ref: z.string().nullable().optional(),
  subpath: z.string().nullable().optional(),
  connectedAppId: z.string().nullable(),
});

export const inspectGitSkillSource = mutator({
  schema: inspectGitSkillSourceSchema,
  resolve: {},
  permissions: [
    {
      permission: "tenant:skill_create",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
    {
      permission: "connected_app:use",
      scopeId: ({ args }) => args.connectedAppId,
    },
  ],
  fn: async ({
    tx,
    ctx,
    args: { sourceId, remoteUrl, ref, subpath, connectedAppId },
  }) => {
    const source = parseGitSkillSource({ remoteUrl, ref, subpath });
    if (connectedAppId) {
      const [connector] = await tx.run(
        zql.connectedApps.where("id", connectedAppId)
      );
      if (
        !connector ||
        !matchesUrlPattern(connector.urlPattern, source.remoteUrl)
      ) {
        throw userFacingError(
          "Choose a connector configured for this repository URL"
        );
      }
    }
    const now = Date.now();
    await tx.mutate.skillGitSources.insert({
      id: sourceId,
      remoteUrl: source.remoteUrl,
      ref: source.ref ?? null,
      subpath: source.subpath ?? null,
      connectedAppId,
      catalog: [],
      resolvedCommit: null,
      syncStartedAt: now,
      lastSyncedAt: null,
      lastError: null,
      createdAt: now,
      createdByUserId: ctx.userId,
      tenantId: ctx.tenantId,
    });
    if (connectedAppId) {
      await recordConnectorUsage(
        tx,
        connectedAppId,
        usageRef.skillGitSource(sourceId),
        ctx.tenantId
      );
    }
  },
});
